<!-- 실시간 유저 포인트 랭킹 -->
<template>
    <div class="userRank_wrap">
        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>
        <div v-else class="ranktable">
            <div class="title">
                <img src="@/assets/imgs/icon/rank.png"> &nbsp;포인트 랭킹
            </div>
            <table>
                <thead>
                    <tr>
                        <th class="ranking">순위</th>
                        <th class="nick">닉네임</th>
                        <th class="point">포인트</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rank, index) in usersRank" :key="index">
                        <td class="ranking">{{index+1}}</td>
                        <td class="nick"> <img :src="`${require('@/assets/imgs/level/'+rank.level+'.png')}`"> <span>{{rank.nic}}</span></td>
                        <td class="point">{{addComma(rank.point)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import { comma } from '../mixins/comma'
export default {
    name:'UserRanking',
    mixins:[ comma ],
    data(){
        return{
            isLoading:true,
            usersRank:[]
        }
    },
    mounted() {
        this.getUsersRank();
    },
    methods:{
        async getUsersRank() {
            try {
                const response = await this.$store.dispatch("users/getUsersRank")
                console.log('유저랭킹',response);
                this.usersRank = response;
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
    }
}
</script>
<style lang="scss" scoped>
.userRank_wrap{
    border:1px solid #dee3eb;
    padding:20px;
    background:#fff;
    font-family: '맑은고딕';
    .ranktable{
        .title{
            padding-bottom:10px;
            text-align: center;
            font-weight: bold;
            font-size:16px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: dotted 1px #ccc;
        }
        table{
            width:100%;
            th,td{padding:5px;}
            th{padding-bottom:20px;}
            .ranking{text-align:center;}
            .nick{
                text-align: left;display: flex;align-items: center;
                span{
                    margin-left:5px;
                }
            }
            .point{text-align:right;}
            tbody{
                tr:nth-child(-n+3){
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
